import { render } from "./OverlayContainer.vue?vue&type=template&id=3eefabaa"
import script from "./OverlayContainer.vue?vue&type=script&lang=js"
export * from "./OverlayContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__